import moment from 'moment';
import React, { Component, useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';

import GoKids from '../../services/GoKids';
import { readPhone } from '../../helpers/format';
import Input from '../../components/Input';
import PageTitle from '../../components/PageTitle';
import DataFetchPage from '../../components/DataFetchPage';
// import SearchField from "react-search-field";
const getColumns = comp => [
  {
    Header: 'Família',
    id: 'displayName',
    accessor: d => d.displayName,
    Cell: ({ value, original }) => (
      <React.Fragment>
        <h4>{value}</h4>
        <p>{original.email}</p>
      </React.Fragment>
    )
  },
  {
    Header: 'Telefone',
    accessor: 'phone.number',
    className: 'text-center',
    Cell: ({ value }) => readPhone(value)
  },
  {
    Header: 'Mãetoristas',
    accessor: 'driverCount',
    className: 'text-center',
    Cell: ({ value }) => (value > 0 ? `${value} cadastro(s)` : <em className="text-muted">não possui</em>)
  },
  {
    Header: 'Data de cadastro',
    className: 'text-center',
    accessor: 'createdAt',
    Cell: ({ value }) => moment(value).format('L LT')
  },
  {
    width: 155,
    className: 'cell-actions',
    filterable: false,
    sortable: false,
    Cell: ({ original }) => (
      <Button size="sm" color="link" href={`/familias/${original._id}/info`}>
        mais informações
      </Button>
    )
  }
];

function FamilyList () {

  const [dados, setDados] = useState();
    const [dadosDefault, setDadosDefault] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [input, setInput] = useState();
    const [requestCount, setRequestCount] = useState(0);



    useEffect(() => {
      loadFromApi()
    }, []);

  async function  loadFromApi() {

    let families = await GoKids.listFamilies()
    let requestC = await GoKids.countFamilyRequest()

    console.log(families);

    setDados(families)
    setDadosDefault(families)
    setRequestCount(requestC  || 0)
    setIsLoading(false)

   
  }

  const updateInput = async (value) => {
    const filtered = dadosDefault.filter(country => {
     return country.displayName.toLowerCase().includes(value.toLowerCase())
    })
    setInput(value);
    setDados(filtered);
 }


  const RenderTopActions = () => (
    <div className="card-top-actions">
    
      <h4>({isLoading ? '...' : dados.length}) usuários encontrados</h4>
      {!isLoading && (
        <Button tag={Link} color="link" to="/familias/solicitacoes">
          Solicitações de orçamento ({requestCount})
        </Button>
      )}
    </div>
  );

  const renderContent = ({ isLoading, data }) => (
    <ReactTable loading={isLoading} data={data ? data.families : []} columns={getColumns(this)} />
  );

    return (
      <React.Fragment>
        <PageTitle title="Famílias" />
        {/* <DataFetchPage
          className="card card-table"
          fetch={this.loadFromApi}
          renderToolbar={this.renderTopActions}
          renderContent={this.renderContent}
        /> */}


        <div className="card card-table">
          <div className="card-top-actions">
         <div style={{float:'left', width:200}} >
         <Input  name="nickname" value={input} onChange={(a,b)=> updateInput(b)} />
        {/*   <SearchField
  placeholder="Search..."
  onChange={(q)=> updateInput(q)}
  searchText=""
  classNames="test-class"
  styles={{float:'left'}}
/>*/}
</div>

         <RenderTopActions />
         </div>
       
        <ReactTable loading={isLoading} data={dados ? dados : []} columns={getColumns(this)} />
        </div>
      </React.Fragment>
    );
  

}

export default FamilyList;



// WEBPACK FOOTER //
// ./src/screens/family/FamilyList.js